import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'

import { Button as MerinioButton } from 'ui'
import { isMobile } from 'services/Utilities'
import { t } from 'translations'

const HomeButton: React.FC = () => {
  const { pathname } = useLocation()
  const buttonSize = isMobile() ? 'btn' : 'btn-sm'

  const HamburgerMenu = () => {
    const navBarId = pathname.includes('/admin') ? 'navBarAdministrationContent' : 'navBarManagerContent'
    return (
      <MerinioButton className={`btn ${buttonSize} btn-outline-light d-md-none`} type="button" data-toggle="collapse" data-target={`#${navBarId}`}>
        <i className="fas fa-bars" style={{ minWidth: '18px' }}></i>
      </MerinioButton>
    )
  }

  const DashboardLink = () => {
    const showButton = pathname.includes('/manage') && !pathname.includes('/manage/dashboard')
    return (
      <div className={`${showButton ? '' : 'invisible'}`}>
        <NavLink to="/manage/dashboard" className={`btn ${buttonSize} btn-outline-light${showButton ? '' : 'invisible'}`}>
          <i className="fad fa-home-lg-alt mr-md-1"></i> <span className="d-none d-md-inline">{t('components.topBar.RETURN_DASHBOARD')}</span>
        </NavLink>
      </div>
    )
  }

  if (pathname.includes('/my')) {
    const showButton = !pathname.includes('/my/home')

    return (
      <div className={`${showButton ? '' : 'invisible'}`}>
        <NavLink to="/my/home" className={`btn ${buttonSize} btn-outline-light`}>
          <i className="fad fa-home-lg-alt mr-md-1"></i> <span className="d-none d-md-inline">{t('components.topBar.RETURN_HOME')}</span>
        </NavLink>
      </div>
    )
  }
  return isMobile() ? <HamburgerMenu /> : <DashboardLink />
}

export default HomeButton
